class InitialPackageType {
  Notes() {
    return 1;
  }
  Verification() {
    return 2;
  }
  RejectActivation() {
    return 3;
  }
  CancelFreePackage() {
    return 4;
  }
  ChangeAddress() {
    return 5
  }
  ChangeGender() {
    return 6;
  }
  ChangeFirstName() {
    return 7;
  }
  ChangeLastName() {
    return 8;
  }
  ChangeFatherName() {
    return 9;
  }
  ChangeBirthDate() {
    return 10;
  }
  
}
export default new InitialPackageType();
